import React from "react";

const AddButton = props => (
  <a className="btn-primary text-white btn-round ml-3 text-decoration-none" data-testid="btn-add-work-items" {...props}>
    <i className="fa fa-plus" aria-hidden="true" />
  </a>
);

export default AddButton;
